import AccountShell
  from "./accountShell";

import NotificationList
  from "../../component/notificationList";

export default function AccountNotifications() {
  return (
    <AccountShell
      title="Thông báo"
      description="Các cập nhật mới nhất"
    >
      <NotificationList />
    </AccountShell>
  );
}
